export const ONBOARDING_COLOR = 'fill-accent-blue-default';